<template>
  <md-card>
    <md-card-header>
      <h4>Filtrar</h4>
    </md-card-header>

    <md-card-content>
      <div
        class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100 md-gutter"
      >
        <div class="md-layout-item md-layout md-size-50">
          <md-field v-if="!showCostomer">
            <label>Estatus</label>
            <md-select v-model="selectedOption">
              <md-option
                v-for="option in options"
                :key="option.id"
                :value="option.value"
                :selected="option.selected"
              >{{ option.text }}</md-option>
            </md-select>
          </md-field>
          <md-field v-else>
            <label>Estatus</label>
            <md-select v-model="selectedCostomer">
              <md-option
                v-for="option in costomerOptions"
                :key="option.id"
                :value="option.value"
                :selected="option.selected"
              >{{ option.text }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-layout md-size-50">
          <md-field>
            <label for="dateOccurred">
              <md-icon>calendar_today</md-icon>Desde
            </label>
            <datetime
              data-vv-name="fromDate"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              input-class="Object"
              title="Desde"
              value-zone="America/Mexico_City"
              v-model="fromDate"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-info md-simple md-just-icon" @click="fromDate = ''">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import moment from "moment";

export default {
  name: "StatusFilter",
  props: {
    showCostomer: {
      type: Boolean,
      default: false,
    },
    auxselected: {
      type: String,
      default: () => "redy-for-custom",
    },
  },
  data() {
    return {
      options: [
        { id: 1, text: "Autorizados", value: "authorized", selected: false },
        { id: 2, text: "Por autorizar", value: "to-authorize", selected: true },
        { id: 3, text: "Rechazados", value: "rejected", selected: false },
        {
          id: 4,
          text: "Listos para el cliente",
          value: "redy-for-custom",
          selected: false,
        },
      ],
      costomerOptions: [
        {
          id: 1,
          text: "Listos para el cliente",
          value: "redy-for-custom",
          selected: false,
        },
        { id: 2, text: "Autorizados", value: "authorized", selected: false },
      ],
      selectedOption: "to-authorize",
      selectedCostomer: "redy-for-custom",
      fromDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
    };
  },
  watch: {
    selectedOption(value) {
      this.$emit("change", {
        status: this.selectedOption,
        from: this.fromDate,
      });
    },
    fromDate(value) {
      if (!this.showCostomer) {
        this.$emit("change", {
          status: this.selectedOption,
          from: this.fromDate,
        });
      } else {
        this.$emit("change", {
          status: this.selectedCostomer,
          from: this.fromDate,
        });
      }
    },
    selectedCostomer(value) {
      this.$emit("change", {
        status: this.selectedCostomer,
        from: this.fromDate,
      });
    },
    auxselected(val) {
      if (val) {
        this.selectedCostomer = this.auxselected;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}

.md-field label {
  top: 1px;
}

.md-button.reload-button .md-button-content i {
  font-size: 32px !important;
}

.rotating {
  transition: transform 1s ease-in-out;
  transform: rotateZ(360deg);
}

.md-field.md-valid .vdatetime {
  color: #4caf50 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/extranet/StatusFilter.vue